import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { selectAllContacts } from '../../../../store/conversationGrid';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';

export default function TableHeaderCheckbox() {
    const dispatch = useAppDispatch();

    const selectAll = useAppSelector(state => {
        return state.conversationGrid?.selectAll || false;
    });

    const selected = useAppSelector(state => {
        return state.conversationGrid?.selected.length || 0;
    });

    const [isIndeterminate, setIsIndeterminate] = React.useState<boolean>(false);

    React.useEffect(() => {
        setIsIndeterminate((!selectAll && selected > 0) || (selectAll && selected > 0));
    }, [selectAll, selected]);

    const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(selectAllContacts({ selectStatus: event.target.checked }));
    };

    return (
        <Tooltip title="Select All">
            <Checkbox
                id="chk_select_all"
                aria-label="Toggle select all contacts"
                value={selectAll}
                checked={selectAll}
                indeterminate={isIndeterminate}
                onChange={handleSelectAll}
            />
        </Tooltip>
    );
}
